import { Navigate, useLocation } from "react-router-dom";


function PrivateRoute({ children, isAuthenticated }) {
  const location = useLocation();

  if (isAuthenticated === true) {
    return children;
  }

  return (
    <Navigate to="/login" replace state={{ from: location }} />
  );
}

export default PrivateRoute;
